var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123.633,
    height: 117.334,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 117.334,
    opacity: 0,
    width: 123.633,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 40.7715C0 67.2852 22.7539 93.2617 57.7148 115.771C58.9355 116.553 60.6445 117.334 61.8164 117.334C63.0371 117.334 64.7461 116.553 65.9668 115.771C100.879 93.2617 123.633 67.2852 123.633 40.7715C123.633 18.9941 108.643 3.4668 88.5742 3.4668C77.0996 3.4668 67.334 9.22852 61.8164 18.0664C56.3477 9.27734 46.582 3.4668 35.0586 3.4668C14.9902 3.4668 0 18.9941 0 40.7715ZM8.64258 40.7715C8.64258 23.6816 19.8242 12.1094 34.9609 12.1094C46.7285 12.1094 53.8086 19.4336 58.0566 26.3184C59.5215 28.5645 60.498 29.248 61.8164 29.248C63.1836 29.248 64.0137 28.5156 65.625 26.3184C70.0684 19.5312 76.9531 12.1094 88.6719 12.1094C103.809 12.1094 114.99 23.6816 114.99 40.7715C114.99 64.3555 90.2832 89.4531 62.9883 107.617C62.4512 107.959 62.0605 108.252 61.8164 108.252C61.5723 108.252 61.1816 107.959 60.6445 107.617C33.3496 89.4531 8.64258 64.3555 8.64258 40.7715Z",
    fill: "#363230"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.8d0e1d6653f163b45d7ca5ee0128591d.svg";
export { ForwardRef as ReactComponent };